/**** cat.Branch */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'PbkGraphicType',
  title: 'Типы графиков работы',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'code',
      title: 'Код',
      type: 'number',
      required: true,
    },
    {
      name: 'title',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
    {
      name: 'short',
      title: 'Условное обозначение',
      type: 'text',
      required: true,
    },
    {
      name: 'start',
      title: 'Начало смены',
      type: 'timeminutes',
      required: false,
    },
    {
      name: 'end',
      title: 'Конец смены',
      type: 'timeminutes',
      required: false,
    },
    {
      name: 'work_hours',
      title: 'Рабочих часов',
      type: 'number',
      required: false,
    },
  ],
  newTemplate: {
    code: null,
    title: '',
    short: '',
    start: null,
    end: null,
    work_hours: null,
  },
  makeIdOnInsert: false,
  // updateField: 'update_date',
  defaultSort: {
    field: 'code',
    direction: 'asc',
  },
  import: {
    header: [
      {
        title: 'code',
        field: 'code',
      },
      {
        title: 'title',
        field: 'title',
      },
      {
        title: 'short',
        field: 'short',
      },
      {
        title: 'start',
        field: 'start',
      },
      {
        title: 'end',
        field: 'end',
      },
      {
        title: 'work_hours',
        field: 'work_hours',
      },
    ],
    example: `1;8-часовой, первая смена;1;7:00;16:00;8`,
    customInsert: 'function (elem, nextIdFunc) { \
      const start = elem.start ? elem.start.split(":").reduce((last, cur, index) => last+parseInt(cur)*(index==0?60:1) ,0) : null;\
      const end = elem.end ? elem.end.split(":").reduce((last, cur, index) => last+parseInt(cur)*(index==0?60:1) ,0) : null;\
      let sql = `INSERT INTO mgt."PbkGraphicType"(code, title, short, "start","end",work_hours) VALUES \
      (\'${elem.code.replace(/\'/g, "\'\'")}\', \'${elem.title.replace(/\'/g, "\'\'")}\', \'${elem.short.replace(/\'/g, "\'\'")}\', ${start}, ${end}, ${elem.work_hours || \'null\'});`;\
      return sql; \
    }'
  },
};

export default config;
